export const getNotificationStyle = (type: string) => {
  switch (type) {
    case 'new_content':
      return { 
        icon: '📚', 
        color: 'from-blue-500 to-cyan-500',
        bgColor: 'bg-blue-50',
        borderColor: 'border-blue-200'
      };
    case 'new_game':
      return { 
        icon: '🎮', 
        color: 'from-purple-500 to-pink-500',
        bgColor: 'bg-purple-50',
        borderColor: 'border-purple-200'
      };
    case 'achievement':
      return { 
        icon: '🏆', 
        color: 'from-yellow-500 to-orange-500',
        bgColor: 'bg-yellow-50',
        borderColor: 'border-yellow-200'
      };
    case 'community_post':
      return { 
        icon: '📢', 
        color: 'from-green-500 to-emerald-500',
        bgColor: 'bg-green-50',
        borderColor: 'border-green-200'
      };
    case 'comment':
      return { 
        icon: '💬', 
        color: 'from-indigo-500 to-violet-500',
        bgColor: 'bg-indigo-50',
        borderColor: 'border-indigo-200'
      };
    case 'message':
      return { 
        icon: '✉️', 
        color: 'from-red-500 to-pink-500',
        bgColor: 'bg-red-50',
        borderColor: 'border-red-200'
      };
    default:
      return { 
        icon: '🔔', 
        color: 'from-gray-500 to-slate-500',
        bgColor: 'bg-gray-50',
        borderColor: 'border-gray-200'
      };
  }
};
